import { api } from "../../App";
import { createNotification } from "../../components/Notifications/Notifications";
import { SET_STUDENTS_LOADING, GET_STUDENT_PASSWORD_INFO } from "../types";

// Бэк возвращает detail строкой ("минимум 8 символов; ...") либо массивом причин
// (строк или объектов { msg }) — приводим к одной читаемой строке.
const getPasswordErrorMessage = (ERR, fallback) => {
  const detail = ERR?.response?.data?.detail;
  if (Array.isArray(detail)) {
    const reasons = detail.map((d) => (typeof d === 'string' ? d : d?.msg)).filter(Boolean);
    return reasons.length ? reasons.join('; ') : fallback;
  }
  return detail || fallback;
};

// data: { new_password, confirm_password, current_password, blocked, need_change_password }
export const changeStudentPassword = (studentId, data) => async (dispatch) => {
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    const response = await api.post(`/students/${studentId}/change-password`, data)
    const message = response.data.message || 'Пароль успешно изменён';
    createNotification('success', message)
    return { success: true, message }
  } catch (ERR) {
    console.log(ERR)
    const message = getPasswordErrorMessage(ERR, 'Ошибка при смене пароля')
    createNotification('error', message)
    return { success: false, message }
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
  }
};

// data: { new_password, confirm_password }
export const changeParentPassword = (studentId, data) => async (dispatch) => {
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    const response = await api.post(`/students/${studentId}/change-parent-password`, data)
    const message = response.data.message || 'Пароль родителей успешно изменён';
    createNotification('success', message)
    return { success: true, message }
  } catch (ERR) {
    console.log(ERR)
    const message = getPasswordErrorMessage(ERR, 'Ошибка при смене пароля родителей')
    createNotification('error', message)
    return { success: false, message }
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
  }
};

// GET /students/{mid}/password-info — статус пароля для диалога смены пароля
export const getStudentPasswordInfo = (studentId) => async (dispatch) => {
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    const { data } = await api.get(`/students/${studentId}/password-info`);
    dispatch({ type: GET_STUDENT_PASSWORD_INFO, payload: data.data || data });
  } catch (ERR) {
    console.log(ERR);
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
  }
};
